// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalEligibilityAddress } from './medicalEligibilityAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityPrescriberResult {
    'inNetwork'?: string;
    'address'?: MedicalEligibilityAddress | null;
    'firstName'?: string;
    'lastName'?: string;
    'npi': string;
    'taxId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityPrescriberResult>> = [
        {
            "name":     "inNetwork",
            "baseName": "inNetwork",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalEligibilityAddress"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityPrescriberResult.attributeTypeMap;
    }
}
